import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, debounceTime } from 'rxjs';
import { LayoutService } from 'src/app/_services/app.layout.service';
import { Table } from 'primeng/table';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { Router } from '@angular/router';
import { LanguageService } from 'src/app/_services/language.service';
import { ModelService } from '../model/model.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  
})
export class DashboardComponent implements OnInit, OnDestroy {
    cameraList:any[] = [];
    editRecordUrl="cameras/camera-edit/update/";
    opportunitiesData:any[]=[];
    isLoaded: Promise<boolean> | undefined;
    showTutorial:boolean=false;
    kpi:any = [];

    user_id:number=0;
    knobValue: number = 90;

    selectedWeek: any;

    weeks: any[] = [];

    barData: any;

    barOptions: any;

    pieData: any;

    pieOptions: any;

    subscription: Subscription;

    cols: any[] = [];
    persiPerc=0;
    apertiPerc=0;
    ordiniPerc=0;
    persiTot=0;
    apertiTot=0;
    ordiniTot=0;

    constructor(
        private apiService: ApiService,
        public globalService : GlobalService,
        public lang:LanguageService,
        private layoutService: LayoutService,
        public mS:ModelService,
        public router: Router,
    ) {
        this.subscription = this.layoutService.configUpdate$
            .pipe(debounceTime(25))
            .subscribe((config) => {
                this.initCharts();
            });
    }

    editPrev(record:any){
        this.router.navigateByUrl('opportunities/opportunity-edit/update/'+record.id);
    }

    ngOnInit(): void {
        this.user_id=this.globalService.getUser().id;
        let user_id=this.globalService.getUser().id;
        
        this.apiService.post('app/opportunities_listall',{limit:10,order_by:'datamodifica',logged_user_id:user_id}).subscribe(data2 => {
        this.opportunitiesData = data2.Result;
        
        this.persiPerc=data2.Stat['persiPerc'];
        this.persiTot=data2.Stat['persiTot'];

        this.apertiPerc=data2.Stat['apertiPerc'];
        this.apertiTot=data2.Stat['apertiTot'];

        this.ordiniPerc=data2.Stat['ordiniPerc'];
        this.ordiniTot=data2.Stat['ordiniTot'];

        this.kpi=[
         
        { label: this.lang.el('APERTI'), color1: '#fbbf24', color2: '#60a5fa', value: this.apertiPerc,valueTot: this.apertiTot, icon: 'pi pi-inbox' },
        { label: this.lang.el('CHIUSI PERSI'), color1: '#60a5fa', color2: '#c084fc', value: this.persiPerc,valueTot: this.persiTot, icon: 'pi pi-image' },
        { label: this.lang.el('ORDINI'), color1: '#34d399', color2: '#fbbf24', value: this.ordiniPerc, valueTot: this.ordiniTot, icon: 'pi pi-table' },
      
    ];

         this.isLoaded = Promise.resolve(true); 
        });
       
        

   

        this.weeks = [
            {
                label: 'Last Week',
                value: 0,
                data: [
                    [65, 59, 80, 81, 56, 55, 40],
                    [28, 48, 40, 19, 86, 27, 90],
                ],
            },
            {
                label: 'This Week',
                value: 1,
                data: [
                    [35, 19, 40, 61, 16, 55, 30],
                    [48, 78, 10, 29, 76, 77, 10],
                ],
            },
        ];

        this.selectedWeek = this.weeks[0];
        this.initCharts();
    }

    edit(user:any){
        this.router.navigateByUrl(this.editRecordUrl+user.id);
    }
    goto(url:string){
        if(url=='nuovopreventivo'){
            this.router.navigateByUrl('opportunities/opportunity-edit/new');
        }
        if(url=='nuovocliente'){
            this.router.navigateByUrl('opportunities/opportunity-edit/new');
        }
        if(url=='nuovocliente'){
            this.router.navigateByUrl('accounts/accounts-edit/new');
        }
        if(url=='elencopreventivi'){
            this.router.navigateByUrl('opportunities');
        }
        if(url=='tutorial'){
            this.showTutorial=true;
           
        }
        
    }

    async initCharts() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue(
            '--text-color-secondary'
        );
        const surfaceBorder =
            documentStyle.getPropertyValue('--surface-border');

        this.barData = {
            labels: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
            datasets: [
                {
                    label: 'Revenue',
                    backgroundColor:
                        documentStyle.getPropertyValue('--primary-500'),
                    barThickness: 12,
                    borderRadius: 12,
                    data: this.selectedWeek.data[0],
                },
                {
                    label: 'Profit',
                    backgroundColor:
                        documentStyle.getPropertyValue('--primary-200'),
                    barThickness: 12,
                    borderRadius: 12,
                    data: this.selectedWeek.data[1],
                },
            ],
        };

        this.pieData = {
            labels: ['Electronics', 'Fashion', 'Household'],
            datasets: [
                {
                    data: [300, 50, 100],
                    backgroundColor: [
                        documentStyle.getPropertyValue('--primary-700'),
                        documentStyle.getPropertyValue('--primary-400'),
                        documentStyle.getPropertyValue('--primary-100'),
                    ],
                    hoverBackgroundColor: [
                        documentStyle.getPropertyValue('--primary-600'),
                        documentStyle.getPropertyValue('--primary-300'),
                        documentStyle.getPropertyValue('--primary-200'),
                    ],
                },
            ],
        };

        this.barOptions = {
            animation: {
                duration: 0,
            },
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                        usePointStyle: true,
                        font: {
                            weight: 700,
                        },
                        padding: 28,
                    },
                    position: 'bottom',
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500,
                        },
                    },
                    grid: {
                        display: false,
                        drawBorder: false,
                    },
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false,
                    },
                },
            },
        };

        this.pieOptions = {
            animation: {
                duration: 0,
            },
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                        usePointStyle: true,
                        font: {
                            weight: 700,
                        },
                        padding: 28,
                    },
                    position: 'bottom',
                },
            },
        };
    }

    onWeekChange() {
        let newBarData = { ...this.barData };
        newBarData.datasets[0].data = this.selectedWeek.data[0];
        newBarData.datasets[1].data = this.selectedWeek.data[1];
        this.barData = newBarData;
    }

    onGlobalFilter(table: Table, event: Event) {
        table.filterGlobal(
            (event.target as HTMLInputElement).value,
            'contains'
        );
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
